export default __webpack_public_path__ + "static/media/radovan_l.03facc38.jpg";